import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import App from './App';
import '@/styles/app.css';
import '@/styles/letterhead-print.css';

import { setupGlobalNumberInputSanitizer } from '@/utils/numberInputSanitizer';
import { errorReporter } from '@/services/errorReporter';

setupGlobalNumberInputSanitizer();
errorReporter.init();

if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('native-app', `native-${Capacitor.getPlatform()}`);
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
